/**
 *
 * Account
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { map, isEqual } from "lodash"
import ModalDeleteSimple from "components/ModalDeleteSimple"
import Loader from "components/Loader"
import { Input, Select, Button } from "antd"
import { Form } from "@ant-design/compatible"
import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectOptionsSelect,
  makeSelectIsLoadingOptionsSelect,
  makeSelectInfoCompany,
  makeSelectIsLoadingInfoCompany,
} from "./selectors"
import {
  getOptionsWatcher,
  getInfoCompanyWatcher,
  getInfoCompanySuccess,
  putInfoCompanyWatcher,
} from "./actions"

// import coolboxLogo from '../../../images/coolbox_logo.png';
import deleteRedLines from "../../../images/delete-red-lines.svg"
import pencilBlue from "../../../images/pencil-blue.svg"
import "@ant-design/compatible/assets/index.css"
import "./index.less"

const FormItem = Form.Item
const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class Account extends React.Component {
  state = {
    nameCompany: "",
    country: undefined,
    size: undefined,
    sector: undefined,
    modalDeleteSimple: false,
    loadingPage: true,
    srcLogo: "",
    srcSendServer: "",
  }

  componentDidMount = () => {
    this.props.getOptionsWatcher()
    this.props.getInfoCompanyWatcher()

    setTimeout(() => {
      this.setState({ loadingPage: false })
    }, 500)
  }

  componentWillUnmount = () => {
    this.props.getInfoCompanySuccess({})
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  selectImageLogo = (event) => {
    const reader = new FileReader()

    if (!event.target.files[0]) return

    if (event.target.files[0].size <= 1024 * 1024 * 2) {
      this.setState({ srcSendServer: event.target.files[0] })
    } else {
      return window.message.error("Error al cargar logo.", 5)
    }

    reader.onload = () => {
      if (reader.result.includes("image")) {
        this.setState({ srcLogo: reader.result })
      } else {
        window.message.error("Error al cargar logo.", 5)
      }
    }

    reader.readAsDataURL(event.target.files[0])
  }

  setStateFromProps = () => {
    const { name, size, country, sector, logo } = this.props.infoCompany
    this.setState({
      nameCompany: name,
      size,
      country,
      sector,
      srcLogo: logo,
    })
  }

  componentDidUpdate = (prevProps) => {
    if (!isEqual(prevProps.infoCompany, this.props.infoCompany)) {
      this.setStateFromProps()
    }
  }

  validateChangeFooter = () => {
    const { name, size, country, sector, logo } = this.props.infoCompany
    const stateContent = {
      name: this.state.nameCompany,
      country: this.state.country,
      size: this.state.size,
      sector: this.state.sector,
      srcLogo: this.state.srcLogo,
    }

    const propsContent = {
      name,
      size,
      country,
      sector,
      srcLogo: logo,
    }

    return !isEqual(stateContent, propsContent)
  }

  sendToServer = () => {
    const { logo } = this.props.infoCompany
    const { srcLogo } = this.state

    if (srcLogo && logo !== srcLogo) {
      const fd = new FormData()
      fd.append("uploaded_file", this.state.srcSendServer)
      fd.append("name", this.state.nameCompany)
      fd.append("country", this.state.country)
      fd.append("size", this.state.size)
      fd.append("sector", this.state.sector)
      this.props.putInfoCompanyWatcher(fd)
    } else {
      const data = {
        name: this.state.nameCompany,
        country: this.state.country,
        size: this.state.size,
        sector: this.state.sector,
        logo: logo === srcLogo ? undefined : "",
      }

      this.props.putInfoCompanyWatcher(data)
    }
  }

  render() {
    const {
      isLoadingOptionsSelect,
      optionsSelect,
      form: { getFieldDecorator },
    } = this.props
    const { loadingPage } = this.state

    if (loadingPage || isLoadingOptionsSelect) {
      return <Loader height="80vh" />
    }
    let sector_id = this.state.sector
    if (this.state.sector == 0) {
      sector_id = null
    }
    return (
      <div className="container-account">
        {this.validateChangeFooter() && (
          <div className="container-account__actions">
            <Button onClick={this.setStateFromProps}>Cancelar</Button>
            <Button
              disabled={!this.state.nameCompany}
              type="primary"
              onClick={this.sendToServer}
              loading={this.props.isLoadingInfoCompany}>
              Guardar
            </Button>
          </div>
        )}
        <Form layout="vertical" className="">
          <FormItem label="Nombre de la empresa">
            {getFieldDecorator("nameCompany", {
              initialValue: this.state.nameCompany,
              rules: [
                { required: true, message: formLabelMessage("es", "required") },
              ],
            })(
              <Input
                maxLength={100}
                placeholder="Empresa"
                style={{ width: 300 }}
                onChange={(e) =>
                  this.setStateFrom("nameCompany", e.target.value)
                }
              />
            )}
          </FormItem>
          <div className="container-account__form-joinoptions">
            <FormItem label="Sector">
              <Select
                placeholder="Seleccionar"
                className="container-account__form-sector"
                loading={isLoadingOptionsSelect}
                value={sector_id}
                onChange={(e) => this.setStateFrom("sector", e)}
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {map(optionsSelect.sectors, ({ id, name }) => {
                  return (
                    <Option key={id} value={id}>
                      {name}
                    </Option>
                  )
                })}
              </Select>
            </FormItem>
            <FormItem label="Tamaño">
              <Select
                placeholder="5 - 10"
                className="container-account__form-sector container-account__form-size"
                loading={isLoadingOptionsSelect}
                value={this.state.size}
                onChange={(e) => this.setStateFrom("size", e)}
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {map(optionsSelect.sizes, ({ id, name }) => {
                  return (
                    <Option key={id} value={id}>
                      {name}
                    </Option>
                  )
                })}
              </Select>
            </FormItem>
            <FormItem label="País">
              <Select
                placeholder="Perú"
                className="container-account__form-sector container-account__form-country"
                loading={isLoadingOptionsSelect}
                value={this.state.country}
                onChange={(e) => this.setStateFrom("country", e)}
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {map(
                  optionsSelect.country,
                  ({ iso_3166_1_alpha2, translations }) => {
                    return (
                      <Option key={iso_3166_1_alpha2} value={iso_3166_1_alpha2}>
                        {translations}
                      </Option>
                    )
                  }
                )}
              </Select>
            </FormItem>
          </div>
          <FormItem label="Logo">
            <p className="container-account__logo-description">
              Se admiten archivos en JPG y PNG. Tamaño máximo de 2MB.
            </p>
            <div className="container-account__logo">
              {!this.state.srcLogo ? (
                <React.Fragment>
                  <Button onClick={() => this.fileInputSelectLogo.click()}>
                    {" "}
                    + Añadir logo
                  </Button>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <img src={this.state.srcLogo} />

                  <div className="container-account__logo-actions">
                    <div
                      onClick={() =>
                        this.setState({ modalDeleteSimple: true })
                      }>
                      <img src={deleteRedLines} />
                    </div>
                    <div onClick={() => this.fileInputSelectLogo.click()}>
                      <img src={pencilBlue} />
                    </div>
                  </div>
                </React.Fragment>
              )}
              <input
                style={{ display: "none" }}
                type="file"
                accept="image/*"
                onChange={this.selectImageLogo}
                ref={(fileInputSelectLogo) =>
                  (this.fileInputSelectLogo = fileInputSelectLogo)
                }
              />
            </div>
          </FormItem>
        </Form>
        <ModalDeleteSimple
          visible={this.state.modalDeleteSimple}
          content={<span>¿Estás seguro de que deseas eliminar el logo?</span>}
          onOk={() => {
            this.setState({ modalDeleteSimple: false, srcLogo: "" })
          }}
          onCancel={() => {
            this.setState({ modalDeleteSimple: false })
          }}
        />
      </div>
    )
  }
}

Account.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  optionsSelect: makeSelectOptionsSelect(),
  isLoadingOptionsSelect: makeSelectIsLoadingOptionsSelect(),
  infoCompany: makeSelectInfoCompany(),
  isLoadingInfoCompany: makeSelectIsLoadingInfoCompany(),
})

function mapDispatchToProps(dispatch) {
  return {
    getOptionsWatcher: () => dispatch(getOptionsWatcher()),
    getInfoCompanyWatcher: () => dispatch(getInfoCompanyWatcher()),
    putInfoCompanyWatcher: (params) => dispatch(putInfoCompanyWatcher(params)),
    getInfoCompanySuccess: (params) => dispatch(getInfoCompanySuccess(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "account", reducer })
const withSaga = injectSaga({ key: "account", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(Form.create({ name: "panel_control_account_form" })(Account))
